module.exports = __webpack_public_path__ + "img/book-open-solid.1f181dfa.svg";